import * as client from '../../services/client';
import { TYPES, ErrorMessages } from '../../common/constants';
import { selectSuiteById } from '../selectors/suites';
import { PATHS } from '../../common/constants';
import {
  startLoading,
  stopLoading,
  startPRLoading,
  stopPRLoading,
  startFormLoading,
  stopFormLoading,
} from '../actions/loader';

import { toast } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
import { fetchSuiteWalkThroughs } from './walkThroughs';
import { fetchCountsDone, fetchPropertyCounts } from './properties';
import { getPropertyBuildings } from './buildings';
import { setSuiteFormData } from './suiteForm';
import moment from 'moment';
import { store } from '..';
import { ToastFail } from '../../helpers/validationHelper';
import { fetchFaqsNotesDocumentsDone } from './faqsNotesDocuments';

const fetchPropertySuitesDone = (payload) => ({
  type: TYPES.FETCH_PROPERTY_SUITES_DONE,
  payload,
});

export const fetchPropertySuites = (id, userId, role, loader) => (dispatch) => {
  if (loader === false) {
  } else {
    dispatch(startPRLoading());
  }
  return client.getPropertySuites(id, userId, role).then((response) => {
    if (response.status === 200) {
      response.json().then((responsejson) => {
        dispatch(fetchPropertySuitesDone(responsejson));
        dispatch(stopPRLoading());
      });
    } else if (response.status === 204) {
      dispatch(fetchPropertySuitesDone([]));
      dispatch(stopPRLoading());
    } else {
      dispatch(stopPRLoading());
    }
  });
};

export const fetchPropertySuitesForTable =
  (id, userId, role, loader) => (dispatch) => {
    if (loader === false) {
    } else {
      dispatch(startPRLoading());
    }
    return client
      .getPropertySuitesForTable(id, userId, role)
      .then((response) => {
        if (response.status === 200) {
          response.json().then((responsejson) => {
            dispatch(fetchPropertySuitesDone(responsejson));
            dispatch(stopPRLoading());
          });
        } else if (response.status === 204) {
          dispatch(fetchPropertySuitesDone([]));
          dispatch(stopPRLoading());
        } else {
          dispatch(stopPRLoading());
        }
      });
  };
export const fetchPropertieSuites = (params, loader) => (dispatch) => {
  if (loader === false) {
  } else {
    dispatch(startPRLoading());
  }
  return client.getPropertiesSuites(params).then((response) => {
    if (response.status === 200) {
      response.json().then((responsejson) => {
        dispatch(fetchPropertySuitesDone(responsejson));
        dispatch(stopPRLoading());
      });
    } else if (response.status === 204) {
      dispatch(fetchPropertySuitesDone([]));
      dispatch(stopPRLoading());
    } else {
      dispatch(stopPRLoading());
    }
  });
};

const saveSuiteDone = (payload) => ({
  type: TYPES.SAVE_SUITE_DONE,
  payload,
});

const setValidation = (payload) => ({
  type: TYPES.SET_VALIDATION,
  payload,
});

export const clearValidation = () => ({
  type: TYPES.CLEAR_VALIDATION,
});

export const saveSuite = (suite) => (dispatch) => {
  dispatch(startFormLoading());
  return client.addSuite(suite).then((response) => {
    dispatch(stopFormLoading());
    dispatch(stopLoading());
    if (response.ok || response.status === 200) {
      response.json().then((responsejson) => {
        dispatch(getPropertyBuildings(suite.PropertyId));
        if (responsejson.statusCode === 402) {
          toast.error('🚫 Unit Number already exits please try with other', {
            autoClose: 12000,
            position: 'top-center',
          });
          dispatch(setValidation('message'));
        } else if (
          responsejson.statusCode === 409 ||
          responsejson.statusCode === 400
        ) {
          toast.error('🚫 User already exist with this email address.', {
            autoClose: 12000,
            position: 'top-center',
          });
          dispatch(setValidation('message'));
        } else if (responsejson.statusCode === 200) {
          dispatch(setValidation('Success'));
          toast.success('ⓘ Suite has been added.', {
            autoClose: 10000,
            position: 'top-center',
          });
          dispatch(saveSuiteDone(responsejson.data));
        } else {
          toast.error(
            ' 🚫 Something went wrong with adding a suite, please try again.',
            { autoClose: 12000, position: 'top-center' }
          );
        }
      });
    } else {
      dispatch(stopFormLoading());
      toast.error(
        ' 🚫 Something went wrong with adding a suite, please try again.',
        { autoClose: 12000, position: 'top-center' }
      );
    }
  });
};

const addDocuments = (data, dispatch) => {
  return client.addFaqsNotesDocuments(data).then((response) => {
    if (response.ok || response.status === 200) {
      response.json().then((responsejson) => {
        dispatch(saveFaqsNotesDocumentsDone(responsejson.data));
      });
    } else {
      toast.error(' 🚫 Something Went Wrong !', {
        autoClose: 12000,
        position: 'top-center',
      });
    }
  });
};

const saveFaqsNotesDocumentsDone = (payload) => ({
  type: TYPES.SAVE_FAQ_NOTES_DOCUMENTS_DONE,
  payload,
});

const updateSuiteDone = (payload) => ({
  type: TYPES.UPDATE_SUITE_DONE,
  payload,
});

export const updateSuite = (suite, history, property) => (dispatch) => {
  dispatch(startFormLoading());
  return client.updateSuite(suite).then((response) => {
    dispatch(stopFormLoading());
    if (response.ok || response.status === 200) {
      response.json().then((responsejson) => {
        dispatch(getPropertyBuildings(suite.propertyId));
        if (responsejson.statusCode === 402) {
          toast.error(
            ' 🚫 That unit number already exits, please try another.',
            {
              autoClose: 12000,
              position: 'top-center',
            }
          );
          dispatch(setValidation('message'));
        } else if (
          responsejson.statusCode === 409 ||
          responsejson.statusCode === 400
        ) {
          toast.error('🚫 User already exist with this email address.', {
            autoClose: 12000,
            position: 'top-center',
          });
          dispatch(setValidation('message'));
        } else if (responsejson.statusCode === 200) {
          toast.success(' ⓘ Suite has been updated.', {
            autoClose: 10000,
            position: 'top-center',
          });
          dispatch(setValidation('Success'));
          if (history) {
            history.push({
              pathname: PATHS.PROPERTIES_VIEW.replace(':id', property.id),
              state: { data: property },
            });
          }
          dispatch(updateSuiteDone(responsejson.data));
        } else {
          dispatch(stopFormLoading());
          toast.error(
            ' 🚫 Something went wrong with updating a suite, please try again.',
            { autoClose: 12000, position: 'top-center' }
          );
        }
      });
    } else {
      dispatch(stopFormLoading());
      toast.error(
        ' 🚫 Something went wrong with updating a suite, please try again.',
        { autoClose: 12000, position: 'top-center' }
      );
    }
  });
};

const deleteUnitDone = (payload) => ({
  type: TYPES.DELETE_UNIT_DONE,
  payload,
});

export const deleteUnit = (id, userId, history, property) => (dispatch) => {
  dispatch(startFormLoading());
  return client.deleteUnit(id, userId).then((response) => {
    dispatch(stopFormLoading());
    if (response.ok || response.status === 200) {
      toast.success(' ⓘ Unit has been deleted.', {
        autoClose: 10000,
        position: 'top-center',
      });
      if (history) {
        history.push({
          pathname: PATHS.PROPERTIES_VIEW.replace(':id', property.id),
          state: { data: property },
        });
      }
      dispatch(deleteUnitDone(id));
    } else {
    }
  });
};

export const clearSuites = () => ({
  type: TYPES.CLEAR_SUITES,
});

const fetchSuiteByIdDone = (payload) => ({
  type: TYPES.FETCH_SUITE_BY_ID_DONE,
  payload,
});

export const fetchSuiteById = (id) => (dispatch, getState) => {
  const suite = selectSuiteById(getState(), id);
  if (!suite) {
    return client
      .getSuiteById(id)
      .then((response) => dispatch(fetchSuiteByIdDone(response.data)));
  }
};

const fetchSuiteNotesDone = (payload) => ({
  type: TYPES.FETCH_SUITE_NOTES_DONE,
  payload,
});

export const fetchSuiteNotes = (id, query) => (dispatch) => {
  return client
    .getSuiteNotes(id, query)
    .then((response) =>
      dispatch(fetchSuiteNotesDone({ id, notes: response.data }))
    );
};

const fetchSuiteDocumentsDone = (payload) => ({
  type: TYPES.FETCH_SUITE_DOCUMENTS_DONE,
  payload,
});
const fetchSuiteAreasDone = (payload) => ({
  type: TYPES.FETCH_SUITE_AREAS_DONE,
  payload,
});

const fetchSuiteUsersDone = (payload) => ({
  type: TYPES.FETCH_SUITE_USERS_LIST,
  payload,
});

export const fetchSuiteDocuments = (id, query) => (dispatch) => {
  return client
    .getSuiteDocuments(id, query)
    .then((response) =>
      dispatch(fetchSuiteDocumentsDone({ id, documents: response.data }))
    );
};

export const fetchSuiteAreas = () => (dispatch) => {
  return client.getSuiteAreas().then((response) => {
    if (response.ok) {
      response.json().then((responsejson) => {
        let other = responsejson.filter((area) => area.name === 'Other');
        responsejson = responsejson.filter((area) => area.name !== 'Other');
        responsejson = [...responsejson, ...other];

        dispatch(fetchSuiteAreasDone(responsejson));
      });
    } else {
      dispatch(fetchSuiteAreasDone([]));
    }
  });
};

export const setWalkThroughStatus = (status, data) => (dispatch) => {
  status = { ...status, ReviewDate: moment().format('MM-DD-YYYY HH:mm:ss') };
  return client
    .setWalkThroughStatus(status)
    .then((response) => {
      if (response.ok || response.status === 200) {
        response.json().then((responsejson) => {
          if (responsejson.statusCode === 200) {
            if (status.Status === 'Review') {
              dispatch(fetchSuiteCounts(status.SuiteId));
              toast.success(
                'ⓘ  Congratulations! You have successfully completed the walk-through, We will send an email notification once the PDF is ready for your review.',
                { autoClose: 3000, position: 'top-center' }
              );
            }
            let state = store.getState();
            const userData = state.auth?.user || {};
            const roleName = userData.roles[0].role.name;
            dispatch(fetchSuiteWalkThroughs(status.SuiteId, roleName));
          } else {
            toast.error(
              ' 🚫 Walkthrough status updating failed, please try again.',
              { autoClose: 3000, position: 'top-center' }
            );
          }
        });
      } else {
        toast.error(' 🚫 Something went wrong, please try again.', {
          autoClose: 3000,
          position: 'top-center',
        });
      }
    })
    .catch(() => {
      toast.error(' 🚫 Something went wrong, please try again.', {
        autoClose: 3000,
        position: 'top-center',
      });
    });
};

export const saveCopySuite = (suite) => (dispatch) => {
  dispatch(startFormLoading());
  return client.addCopySuite(suite).then((response) => {
    dispatch(stopFormLoading());
    dispatch(stopLoading());
    if (response.ok || response.status === 200) {
      response.json().then((responsejson) => {
        if (responsejson.statusCode === 402) {
          toast.error('🚫 Unit Number already exits please try with other', {
            autoClose: 12000,
            position: 'top-center',
          });
          dispatch(setValidation('message'));
        } else if (
          responsejson.statusCode === 409 ||
          responsejson.statusCode === 400
        ) {
          toast.error('🚫 User already exist with this email address.', {
            autoClose: 12000,
            position: 'top-center',
          });
          dispatch(setValidation('message'));
        } else if (responsejson.statusCode === 200) {
          dispatch(setValidation('Success'));
          toast.success('ⓘ Suite has been added.', {
            autoClose: 10000,
            position: 'top-center',
          });
          dispatch(saveSuiteDone(responsejson.data));
        } else {
          toast.error('ⓘ Suite adding failed.', {
            autoClose: 10000,
            position: 'top-center',
          });
        }
      });
    } else {
      dispatch(stopFormLoading());
    }
  });
};

const fetchedSuiteUsersAddToContactsDone = (payload) => ({
  type: TYPES.FETCHED_SUITE_USERS_ADD_TO_CONTACTS_DONE,
  payload,
});
export const fetchSuiteUsers = (suiteId, type) => (dispatch) => {
  if (type !== false) {
    dispatch(startPRLoading());
  }
  return client
    .fetchSuiteUsers(suiteId)
    .then((response) => {
      if (response.status === 200 && response.ok) {
        dispatch(stopPRLoading());
        response.json().then((responsejson) => {
          dispatch(fetchSuiteUsersDone(responsejson));
          dispatch(fetchedSuiteUsersAddToContactsDone(responsejson));
        });
      } else {
        dispatch(stopPRLoading());
        dispatch(fetchSuiteUsersDone([]));
      }
    })
    .catch(() => {
      dispatch(stopPRLoading());
    });
};

export const clearSuiteUsers = () => ({
  type: TYPES.CLEAR_SUITE_USERS,
});

export const fetchSuiteCounts = (suiteId, role) => (dispatch) => {
  return client.fetchSuiteCounts(suiteId, role).then((response) => {
    if (response.status === 200 || response.ok) {
      response.json().then((responsejson) => {
        if (responsejson.statusCode === 200) {
          dispatch(fetchCountsDone(responsejson.data));
        }
      });
    }
  });
};

const fetchMaintainanceGuidesBySuiteIdDone = (payload) => ({
  type: TYPES.FETCH_MAINTAINANCE_GUIDE_BY_SUITE_ID,
  payload,
});

export const fetchMaintainanceGuideBySuiteId = (id) => (dispatch) => {
  dispatch(startPRLoading());
  return client.fetchMaintainanceGuideBySuiteId(id).then((response) => {
    if (response.ok || response.status === 200) {
      response.json().then((responsejson) => {
        dispatch(fetchMaintainanceGuidesBySuiteIdDone(responsejson));
        dispatch(stopPRLoading());
      });
    }
  });
};

export const addExistingUser = (data, actionType) => (dispatch) => {
  dispatch(startFormLoading());
  return client
    .addExistingUser(data)
    .then((response) => {
      dispatch(stopFormLoading());
      dispatch(setValidation('Contact'));
      if (response.status === 200 || response.ok) {
        response.json().then((responsejson) => {
          if (actionType === 'saveAndAdd') {
            dispatch(fetchSuiteUsers(data.SuiteId, false));
          } else {
            dispatch(fetchSuiteUsers(data.SuiteId));
          }
          if (responsejson.statusCode === 200) {
            toast.success('ⓘ Contact has been added successfully.', {
              autoClose: 10000,
              position: 'top-center',
            });
          } else {
            toast.success(' 🚫 Contact adding failed.', {
              autoClose: 10000,
              position: 'top-center',
            });
          }
        });
      } else {
        toast.error(
          ' 🚫 Something went wrong with adding a contact, please try again.',
          { autoClose: 12000, position: 'top-center' }
        );
      }
    })
    .catch((error) => {
      dispatch(stopFormLoading());
      toast.error(
        ' 🚫 Something went wrong with adding a contact, please try again.',
        { autoClose: 12000, position: 'top-center' }
      );
    });
};
export const onSubmitKeyhandOffProcess =
  (params, propertyId, userId, role) => (dispatch) => {
    dispatch(startFormLoading());
    client
      .onSubmitKeyhandOffProcess(params)
      .then((response) => {
        if (response.status === 200) {
          dispatch(stopFormLoading());
          dispatch(setValidation('KeyHandOff'));
          response.json().then((responsejson) => {
            if (responsejson.statusCode === 200) {
              dispatch(clearkeyPickupDone());
              dispatch(setSuiteFormData({ isKeyHandOff: true }));
              dispatch(fetchPropertySuites(propertyId, userId, role));
              toast.success('ⓘ Key Pickup process submited successfully.', {
                autoClose: 10000,
                position: 'top-center',
              });
            } else {
              toast.error('ⓘ Key Pickup process submit failed.', {
                autoClose: 10000,
                position: 'top-center',
              });
            }
          });
        } else {
          dispatch(stopFormLoading());
          dispatch(setValidation('KeyHandOff'));
          toast.error('ⓘ KeyHandOff process submit failed.', {
            autoClose: 10000,
            position: 'top-center',
          });
        }
      })
      .catch((error) => {
        dispatch(stopFormLoading());
        dispatch(setValidation('KeyHandOff'));
        toast.error(
          ' 🚫 Something went wrong with on submit the KeyHandOff process, please try again.',
          { autoClose: 12000, position: 'top-center' }
        );
      });
  };

export const reRenderKeyPickupPdf = (suiteId) => (dispatch) => {
  dispatch(startFormLoading());
  client.reRenderKeyPickupPdf(suiteId).then((response) => {
    if (response.status === 200 || response.ok) {
      dispatch(stopFormLoading());
      toast.success('ⓘ Key Pickup Confirmation re-sent', {
        autoClose: 10000,
        position: 'top-center',
      });
      return;
    }

    dispatch(stopFormLoading());
    toast.error(`ⓘ KeyHandOff process submit failed. (${response.status})`, {
      autoClose: 10000,
      position: 'top-center',
    });
  });
};

export const onFetchSuiteDetails = (suiteId, userId, role) => (dispatch) => {
  dispatch(startLoading());
  client
    .onFetchSuiteDetails(suiteId, userId, role)
    .then((response) => {
      if (response.status === 200) {
        response.json().then((responsejson) => {
          dispatch(setSuiteFormData(responsejson));
          dispatch(stopLoading());
        });
      } else {
        dispatch(setSuiteFormData({}));
        dispatch(stopLoading());
      }
    })
    .catch((error) => {
      dispatch(setSuiteFormData({}));
      dispatch(stopLoading());
      toast.error(
        ' 🚫 Something went wrong with fetching suite details, please try again.',
        { autoClose: 12000, position: 'top-center' }
      );
    });
};

export const onFetchMoreDetails = (id) => (dispatch) => {
  dispatch({
    type: TYPES.IS_FETCH_MORE_DETAILS_LOADING,
  });
  client
    .onFetchMoreDetails(id)
    .then((response) => {
      dispatch(stopLoading());
      if (response.status === 200) {
        response.json().then((responseJson) => {
          dispatch({
            type: TYPES.FETCH_MORE_DETAILS_DONE,
            payload: responseJson,
          });
        });
      } else {
        dispatch({
          type: TYPES.CLOSE_FETCH_MORE_DETAILS_LOADING,
        });
      }
    })
    .catch((error) => {
      dispatch({
        type: TYPES.CLOSE_FETCH_MORE_DETAILS_LOADING,
      });
    });
};
export const onClearMoreDetails = () => (dispatch) => {
  dispatch({
    type: TYPES.CLEAR_MORE_DETAILS_DONE,
  });
};

export const onFetchContactMoreDetails = (id) => (dispatch) => {
  dispatch({
    type: TYPES.IS_FETCH_MORE_DETAILS_LOADING,
  });
  client
    .onFetchContactMoreDetails(id)
    .then((response) => {
      dispatch(stopLoading());
      if (response.status === 200) {
        response.json().then((responseJson) => {
          dispatch({
            type: TYPES.FETCH_MORE_DETAILS_DONE,
            payload: responseJson,
          });
        });
      } else {
        dispatch({
          type: TYPES.CLOSE_FETCH_MORE_DETAILS_LOADING,
        });
      }
    })
    .catch((error) => {
      dispatch({
        type: TYPES.CLOSE_FETCH_MORE_DETAILS_LOADING,
      });
    });
};

export const saveBulkSuites = (params, role) => (dispatch) => {
  dispatch(startPRLoading());
  return client
    .addBulkSuites(params)
    .then((response) => {
      dispatch(stopPRLoading());
      if (response.status === 200) {
        response.json().then((responseJson) => {
          if (responseJson && responseJson.statusCode === 200) {
            dispatch(
              fetchPropertySuites(params.propertyId, params.userId, role)
            );
            dispatch(
              fetchPropertyCounts(params.propertyId, params.userId, role)
            );
            dispatch(setValidation('Suites Imported'));
            dispatch(onSaveResponseDone(responseJson.data));
          } else {
            ToastFail(ErrorMessages.suitesImportError);
          }
        });
      } else {
        ToastFail(ErrorMessages.suitesImportError);
      }
    })
    .catch(() => {
      dispatch(stopPRLoading());
      ToastFail(ErrorMessages.error);
    });
};

export const onSaveResponseDone = (payload) => (dispatch) => {
  dispatch({
    type: TYPES.SAVE_SUITE_RESPONSE_DONE,
    payload: payload,
  });
};

export const onSaveItemsResponseDone = (payload) => (dispatch) => {
  dispatch({
    type: TYPES.SAVE_ITEMS_RESPONSE_DONE,
    payload: payload,
  });
};

export const onClearResponseDone = () => (dispatch) => {
  dispatch({
    type: TYPES.CLEAR_RESPONSE_DONE,
  });
};

export const onFetchSuiteFaqs = (suiteId) => (dispatch) => {
  dispatch(startPRLoading());
  return client
    .fetchSuiteFaqs(suiteId)
    .then((response) => {
      dispatch(stopPRLoading());
      if (response.status === 200) {
        response.json().then((responseJson) => {
          dispatch(fetchFaqsNotesDocumentsDone(responseJson));
        });
      } else {
        ToastFail(ErrorMessages.error);
        dispatch(stopPRLoading());
      }
    })
    .catch(() => {
      ToastFail(ErrorMessages.error);
      dispatch(stopPRLoading());
    });
};

export const onFetchSuiteTopFaqs = (suiteId) => (dispatch) => {
  dispatch(startPRLoading());
  return client
    .fetchSuiteTopFaqs(suiteId)
    .then((response) => {
      dispatch(stopPRLoading());
      if (response.status === 200) {
        response.json().then((responseJson) => {
          dispatch(fetchSuiteFaqsDone(responseJson));
        });
      } else {
        ToastFail(ErrorMessages.error);
        dispatch(stopPRLoading());
      }
    })
    .catch(() => {
      ToastFail(ErrorMessages.error);
      dispatch(stopPRLoading());
    });
};

export const fetchSuiteFaqsDone = (data) => (dispatch) => {
  dispatch({
    type: TYPES.FETCH_SUITE_FAQS_DONE,
    payload: data,
  });
};

export const onFetchkeypickupServiceRequestsDone = (data) => (dispatch) => {
  dispatch({
    type: TYPES.FETCH_KEY_PICKUP_SERVICE_REQUESTS_DONE,
    payload: data,
  });
};
export const onFetchkeypickupImportantDocumentsDone = (data) => (dispatch) => {
  dispatch({
    type: TYPES.FETCH_KEY_PICKUP_IMPORTANT_DOCUMENTS_DONE,
    payload: data,
  });
};

export const clearkeyPickupDone = () => (dispatch) => {
  dispatch({
    type: TYPES.CLEAR_KEY_PICKUP_DONE,
  });
};
export const keyPickupLoadingDone = () => (dispatch) => {
  dispatch({
    type: TYPES.KEY_PICKUP_LOADING_DONE,
  });
};

export const fetchkeypickupServiceRequests = (suiteId) => (dispatch) => {
  dispatch(keyPickupLoadingDone());
  return client
    .fetchkeypickupServiceRequests(suiteId)
    .then((response) => {
      if (response.status === 200) {
        response.json().then((responseJson) => {
          dispatch(onFetchkeypickupServiceRequestsDone(responseJson));
        });
      } else {
        dispatch(onFetchkeypickupServiceRequestsDone([]));
      }
    })
    .catch(() => {
      dispatch(onFetchkeypickupServiceRequestsDone([]));
    });
};

export const fetchkeypickupImportantDocuments = (suiteId) => (dispatch) => {
  return client
    .fetchkeypickupImportantDocuments(suiteId)
    .then((response) => {
      if (response.status === 200) {
        response.json().then((responseJson) => {
          dispatch(onFetchkeypickupImportantDocumentsDone(responseJson));
        });
      } else {
        dispatch(onFetchkeypickupImportantDocumentsDone([]));
      }
    })
    .catch(() => {
      dispatch(onFetchkeypickupImportantDocumentsDone([]));
    });
};

export const updateMobileSync = (suiteId, mobileSyncAllowed) => (dispatch) => {
  dispatch(startFormLoading());
  return client
    .updateSuiteSynchronization(suiteId, mobileSyncAllowed)
    .then((response) => {
      dispatch(stopFormLoading());
      if (response.ok || response.status === 200) {
        dispatch({
          type: TYPES.SUITE_UPDATE_SYNC_STATUS_DONE,
          payload: { suiteId, mobileSyncAllowed },
        });
      } else {
        toast.error('🚫 Mobile Sync update failed.', {
          autoClose: 10000,
          position: 'top-center',
        });
      }
    })
    .catch(() => {
      toast.error('🚫 Mobile Sync update failed.', {
        autoClose: 10000,
        position: 'top-center',
      });
    });
};
